<template>
 <Head>
    <title> Dashboard | {{$page.props.appName}}</title>
    <meta name="description" :content="'View Announcement' + $page.props.appName">
  </Head>
    <div class="w-full flex p-3 xl:flex-row lg:flex-row md:flex-col sm:flex-col flex-col items-center justify-center">
    
    
    
        <Link href="/skills" class="xl:w-1/3 lg:w-1/3 md:w-1/2 sm:w-full w-full my-2 h-52 border-radius text-center flex items-center justify-center shadow-md mx-2 bg-black text-white font-bold">
    
            <div class="flex items-center flex-col">
                <svg class="w-24 h-24" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M12 14l9-5-9-5-9 5 9 5z"></path><path d="M12 14l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14z"></path><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 14l9-5-9-5-9 5 9 5zm0 0l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14zm-4 6v-7.5l4-2.222"></path></svg>
    
            <p>Skills & Competency Record</p>
            </div>
    
    
    
        </Link>
    
    
    
        <Link href="/personal-details" class="xl:w-1/3 lg:w-1/3 md:w-1/2 sm:w-full w-full my-2 h-52 border-radius text-center flex items-center justify-center shadow-md mx-2 bg-black text-white font-bold">
    
            <div class="flex items-center flex-col">
                <svg class="w-24 h-24" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"></path></svg>
    
        <p>Personal Details</p>
            </div>
    
        </Link>
    
    
    
        <Link href="/announcements" class="relative xl:w-1/3 lg:w-1/3 md:w-1/2 sm:w-full w-full my-2 h-52 border-radius text-center flex items-center justify-center shadow-md mx-2 bg-black text-white font-bold">
    
            <div class="flex items-center flex-col">
                <svg class="w-24 h-24" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"></path></svg>
    
                <p>Announcements</p>
                <div class="announcment_count" v-if="announcements>0">
                    {{announcements}}
                </div>
            </div>
    
    
    
        </Link>
    
    
    
    </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import { Link } from '@inertiajs/inertia-vue3'
import { Head } from '@inertiajs/inertia-vue3'

export default {
    layout: Layout,
    props : {
        announcements : Number
    },
    components: { Link, Head}
}
</script>